/**
 * SF-5172: on stage and a developer's machine, says which back office this is across the top of
 * every page (the sign-in page too), kept in view while scrolling, so nobody expects a change
 * there to reach live customers. Production shows nothing: it is the normal back office.
 */
import { theme } from 'antd';
import { APP_ENVIRONMENT } from '../../config/env';
import { showsEnvironmentBar } from './environmentBarSpace';
import './EnvironmentBar.css';

/** Above page content and the layout header (z-index 1); below antd pop-ups (1000 and up). */
const Z_INDEX = 100;

export const EnvironmentBar: React.FC = () => {
  const { token } = theme.useToken();
  if (!showsEnvironmentBar()) return null;
  const look =
    APP_ENVIRONMENT === 'development'
      ? { text: 'Local back office', background: token.colorFillSecondary, color: token.colorText }
      : {
          text: 'Stage back office. Test data, not live customers.',
          background: token.colorWarning,
          color: token.colorText,
        };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: Z_INDEX,
        height: 'var(--sf-environment-bar-height)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 12px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        background: look.background,
        color: look.color,
        fontWeight: 600,
      }}
    >
      {look.text}
    </div>
  );
};
